import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/tailwind.css'
import './styles/components.css'
import './styles/landing.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
